<script setup lang="ts">
import { useCoreConfig } from '#imports'

const { company } = useCoreConfig()
</script>

<template>
    <div v-if="company" class="company-information-panel" data-test="div-contact-info">
        <address>
            <strong>{{ company.name }}</strong><br>
            {{ company.address }}<br>
            {{ company.postcode }} {{ company.city }}, {{ company.country }}<br>
            {{ company.registrationId }}
        </address>
    </div>
</template>

<style lang="scss" scoped>
.company-information-panel {
    margin-bottom: 20px;
    padding: 19px;
    border: 1px solid $panel-border-color;
    border-radius: var(--border-radius, $border-radius);
    background-color: $panel-footer-color;

    address {
        margin-bottom: 0;
        color: $subtle-text-color;
        font-size: $font-size-sm;

        @media (min-width: $screen-sm) {
            font-size: $font-size-base;
        }

        @media (min-width: $screen-md) {
            font-size: $font-size-sm;
        }
    }
}
</style>
